import BasePolicy from '@/policies/BasePolicy.js';

export default class InterventionPolicy extends BasePolicy {
    viewAny(user) {
        return false;
    }
}
